import React, { useMemo, useState, useEffect } from "react";
import { Grid, Paper, Typography, Button, Tabs, Tab, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {currencyFormatNoDecimals, formatNumberToPercentage, mergeClientCoClientAge} from "../../shared/shared";
import { useCookies } from "react-cookie";
import { GraphicPie } from '../graphic-pie'
import DinamicTable from "../dinamic-table";

const PresentationFuture = (props) => {

  const client = useSelector((state) => state.dataStore.get("currentClient"));
  const successProbabilityCurrentPlan = props.successProbabilityCurrent;
  const successProbabilityFuturePlan = props.successProbabilityFuture;
  const futureCashInflow = useSelector((state) => state.dataStore.get("currentFuturePlanCashFlow"));
  const [tab, setTab] = useState(2);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const fiaReports = futureCashInflow?.toJS()?.fiaReport.filter(item => item.length > 0) || [[]];
  const insuranceReports = futureCashInflow?.toJS()?.insurance.filter(e => e.length > 0) || [];

  const getFutureCashflowItemForYear = (year) => {
    return props.futurePlanCashflow.cashOutflow.find(item => {
      return item.year === year;
    });
  };

  return (
    <Grid className={"presentation-current-plan"} container spacing={3}>
      <Grid item xs={5} >
        <Grid container>
          <Grid item xs={12}>
            <Typography component={"h1"}>
              {client.getIn(["client", "firstName"])}{" "}
              {client.getIn(["client", "lastName"])}
            </Typography>
            <hr />
            <Typography component={"p"} fontWeight={'bold'}>
              {`By utilizing various financial strategies including volatility buffers, ROTH IRA conversions, lifetime income annuities, life insurance, and making your portfolio as efficient as possible, your probability of success has changed from ${successProbabilityCurrentPlan}% to ${successProbabilityFuturePlan}%`}
            </Typography>
          </Grid>
        </Grid>

      </Grid>
      <Grid item xs={7} className={"presentation-current-plan-right-panel"}>
        <Grid container >
          <Grid xs={12} >
            <Grid container className={'wealth-summary-table'}>
              <Grid item xs={2} ></Grid>
              <Grid item xs={4} className={'center-element text-future-header-table'} >CURRENT </Grid>
              <Grid item xs={4} className={'center-element text-future-header-table'} >FUTURE </Grid>
              <Grid item xs={2} ></Grid>
            </Grid>
            <Paper elevation={0} className={'wealth-summary-table'}>
              <Grid container >
              </Grid>
              <Grid container>
                <Grid item xs={2} display={'flex'} alignItems={'center'} >PROBABILITY OF SUCCESS</Grid>
                <Grid item xs={4} className={'center-element'}>
                  <GraphicPie
                    value={successProbabilityCurrentPlan}
                    width={160}
                    innerRadius={14}
                    numberDistanceX={-5}
                    fontSizeNumber={50}
                    fontSizeSymbol={25}
                    symbolDistanceX={successProbabilityCurrentPlan >= 100 ? 35 : 25}
                    symbolDistanceY={12} />
                </Grid>
                <Grid item xs={4} className={'center-element'}>
                  <GraphicPie
                    value={successProbabilityFuturePlan}
                    width={160}
                    innerRadius={14}
                    numberDistanceX={-5}
                    fontSizeNumber={50}
                    fontSizeSymbol={25}
                    symbolDistanceX={successProbabilityFuturePlan >= 100 ? 35 : 25}
                    symbolDistanceY={12} />
                </Grid>
              </Grid>
              <div className={'line-table-dashed'} > </div>

              <Grid container mt={2}>
                <Grid item xs={1} className={'center-element text-future-header-title-table'}>
                  Year
                </Grid>
                <Grid item xs={1} className={'center-element text-future-header-title-table'}>
                  Age
                </Grid>
                <Grid item xs={4} className={'center-element text-future-header-title-table'}>
                  Total current
                </Grid>
                <Grid item xs={4} className={'center-element text-future-header-title-table'}>
                  Total future
                </Grid>
                <Grid item xs={2} className={'center-element text-future-header-title-table'}>
                  Change
                </Grid>
              </Grid>
              {/* content table */}
              {props.tableCurrentFuture?.length > 0 ?
                props.tableCurrentFuture.map(item => {

                  const increaseClass = item.increase < 0 ? "diff-red" : "diff-green";

                  return (
                    < div key={item.age}>
                      <Grid container mt={2}>
                        <Grid item xs={1} className={'center-element text-future-content-year-age-table'}>
                          {item.year}
                        </Grid>
                        <Grid item xs={1} className={'center-element text-future-content-year-age-table'}>
                          {item.age}
                        </Grid>
                        <Grid item xs={4} className={'center-element text-future-content-current-table'}>
                          {item.totalCurrent}
                        </Grid>
                        <Grid item xs={4} className={'center-element text-future-content-future-table'}>
                          {item.totalFuture}
                        </Grid>
                        <Grid item xs={2} className={`center-element text-future-content-increase-table ${increaseClass}`}>
                          {item.increase}
                        </Grid>
                      </Grid>
                      <div className={'line-table-dashed'} > </div>
                    </div>
                  )
                })
                :
                <Grid mt={5} container justifyContent={'center'} alignItems={'center'}> <Typography component={'h4'} variant={'h4'}>  </Typography> </Grid>}
            </Paper>

            <Paper elevation={0} className={'wealth-summary-table'}>
              <Grid container mt={2}>
                <Grid item xs={1} className={'center-element text-future-header-title-table'}>
                  Year
                </Grid>
                <Grid item xs={1} className={'center-element text-future-header-title-table'}>
                  Age
                </Grid>
                <Grid item xs={4} className={'center-element text-future-header-title-table'}>
                  Taxes current
                </Grid>
                <Grid item xs={4} className={'center-element text-future-header-title-table'}>
                  Taxes future
                </Grid>
                <Grid item xs={2} className={'center-element text-future-header-title-table'}>
                  Change
                </Grid>
              </Grid>
              {props.currentPlanCashflow.cashOutflow.map((item, index) => {

                const lastIndex = props.currentPlanCashflow.cashOutflow.length - 1;
                if (index !== 10 && index !== 20 && index !== lastIndex) return <></>;

                const futureOutflowItem = getFutureCashflowItemForYear(item.year);

                const futureTotalTax = (futureOutflowItem?.incomeTax + futureOutflowItem?.capitalGainsTax);
                const currentTotalTax = (item?.incomeTax + item?.capitalGainsTax);

                const totalTaxDifference = futureTotalTax - currentTotalTax;
                const socialSecurityDifference = futureOutflowItem.socialSecurityTax - item.socialSecurityTax;

                const totalTaxDiffClass = totalTaxDifference < 0 ? "diff-red" : "diff-green";
                const socialTaxDiffClass = socialSecurityDifference < 0 ? "diff-red" : "diff-green";

                return  <div key={item.age}>
                  <Grid container mt={2}>
                    <Grid item xs={1} className={'center-element text-future-content-year-age-table'}>
                      {item.year}
                    </Grid>
                    <Grid item xs={1} className={'center-element text-future-content-year-age-table'}>
                      {item.clientAge}
                    </Grid>
                    <Grid item xs={4} className={'center-element text-future-content-current-table'}>
                      {currencyFormatNoDecimals(currentTotalTax)}
                    </Grid>
                    <Grid item xs={4} className={'center-element text-future-content-future-table'}>
                      {currencyFormatNoDecimals(futureTotalTax)}
                    </Grid>
                    <Grid item xs={2} className={`center-element text-future-content-increase-table ${totalTaxDiffClass}`}>
                      {currencyFormatNoDecimals(totalTaxDifference)}
                    </Grid>
                  </Grid>
                  <Grid container mt={2} className={"social-security-tax-item"}>
                    <Grid item xs={1} className={'center-element text-future-content-year-age-table'}>

                    </Grid>
                    <Grid item xs={1} className={'center-element text-future-content-year-age-table'}>

                    </Grid>
                    <Grid item xs={4} className={'center-element text-future-content-current-table'}>
                      {currencyFormatNoDecimals(item.socialSecurityTax)}
                    </Grid>
                    <Grid item xs={4} className={'center-element text-future-content-future-table'}>
                      {currencyFormatNoDecimals(futureOutflowItem.socialSecurityTax)}
                    </Grid>
                    <Grid item xs={2} className={`center-element text-future-content-increase-table ${socialTaxDiffClass}`}>
                      {currencyFormatNoDecimals(socialSecurityDifference)}
                    </Grid>
                  </Grid>
                  <div className={'line-table-dashed'} > </div>
                </div>
              })}
              <Grid container mt={2}>
                <Grid item xs={2} className={'text-future-paidtaxes-year-age-table'}>
                  {"Paid total in taxes"}
                </Grid>
                <Grid item xs={4} className={'center-element text-future-content-current-table'}>
                  {currencyFormatNoDecimals(props.totalTaxesPaidCurrent)}
                </Grid>
                <Grid item xs={4} className={'center-element text-future-content-future-table'}>
                  {currencyFormatNoDecimals(props.totalTaxesPaidFuture)}
                </Grid>
                <Grid item xs={2} className={'center-element text-future-content-increase-table'}>
                  {currencyFormatNoDecimals(props.totalTaxesPaidFuture - props.totalTaxesPaidCurrent)}
                </Grid>
              </Grid>
              <div className={'line-table-dashed'} > </div>

              <Grid container mt={2}>
                <Grid item xs={2} className={'text-current-footer-SS-table'}>
                  {"SS Taxes"}
                </Grid>
                <Grid item xs={4} className={'center-element text-future-footer-money-table'}>
                  {currencyFormatNoDecimals(props.totalSSCurrent)}
                </Grid>
                <Grid item xs={4} className={'center-element text-future-footer-money-table'}>
                  {currencyFormatNoDecimals(props.totalSSFuture)}
                </Grid>
                <Grid item xs={2} className={'center-element text-future-footer-money-table'}>
                  {currencyFormatNoDecimals(props.totalSSFuture - props.totalSSCurrent)}
                </Grid>
              </Grid>
            </Paper>
          </Grid>

        </Grid>
      </Grid>

      {/* Inflow, Outflow, Accounts Summary, Summary Cash Flow, FIA Report, and Insurance */}
      <Grid className={"presentation-current-plan-more-info"} justifyContent={"space-around"} alignItems={"center"} container >
        <Grid item xs={12} m={0} p={0}>
          <Tabs
            style={{ marginTop: "2rem" }}
            indicatorColor={"primary"}
            value={tab}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Inflow" />
            <Tab label="Outflow" />
            <Tab label="Accounts Summary" />
            <Tab label="Summary Cash Flow" />
            <Tab style={{ display: props.showFiaReport ? '' : 'none' }} label="FIA Report" />
            {insuranceReports.length > 0 && <Tab label="Insurance" />}
            {tab === 6 ? <Tab style={{ display: 'none' }} /> : null}
          </Tabs>
        </Grid>
        <Grid className={"presentation-current-plan-future"} item xs={4} mt={2}>

        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div >
          {tab === 0 && (
            <DinamicTable
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year" },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["payroll"], title: "Payroll", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["socialSecurity"], title: "Social Security", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["pension"], title: "Pension", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["other"], title: "Other Income", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredDistributions"], title: "Tax Deferred Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableDistributions"], title: "Taxable Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptDistributions"], title: "Tax Exempt Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaWithdrawal"], title: "FIA Withdrawal", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalInFlow"], title: "Total Inflows", function: currencyFormatNoDecimals },
              ]}
              data={futureCashInflow.toJS().cashInflow}
            />
          )}

          {tab === 1 && (
            <DinamicTable
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year" },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["retirementBudget"], title: "Retirement Budget", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["socialSecurityTax"], title: "Social Security Tax", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["capitalGainsTax"], title: "Capital Gains Tax", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["incomeTax"], title: "Income Tax", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalOutFlow"], title: "Total Outflows", function: currencyFormatNoDecimals },
              ]}
              data={futureCashInflow.toJS().cashOutflow}
            />
          )}
          {tab === 2 && (
            <DinamicTable
              extraHeaderRow={true}
              extraHeaderRowColSpan={[
                { col: 1 },
                { col: 1 },
                { className: 'extra-row-cash-flow', col: 2, title: 'Taxable' },
                { className: 'extra-row-cash-flow', col: 2, title: 'Tax Deferred' },
                { className: 'extra-row-cash-flow', col: 2, title: 'Tax Exempt' },
                { className: 'extra-row-cash-flow', col: 2, title: 'RILA/Vol Buff FIA' },
                { className: 'extra-row-cash-flow', col: 2, title: 'Vol Buff Ins' },
                { className: 'extra-row-cash-flow', col: 1 },
                { col: 1 },
                { col: 1 },
                { col: 1 },
              ]}
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year" },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaAccountBalance"], title: "Acct Balance", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaAccountGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceNetCashValue"], title: "Net Cash Value", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceGrossDistribution"], title: "Gross Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["portfolioReturns"], title: "Port Returns", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaIndexReturn"], title: "RILA/FIA Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceCashValueReturn"], title: "Cash Val Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalAccountValue"], title: "Total Account Value", function: currencyFormatNoDecimals },
              ]}
              data={futureCashInflow?.toJS()?.accountsSummary || []}
            />
          )}
          {tab === 3 && (
            <DinamicTable
              extraHeaderRow={true}
              extraHeaderRowColSpan={[
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 3, className: 'extra-row-cash-flow', title: 'Taxable' },
                { col: 2, className: 'extra-row-cash-flow', title: 'Tax Deferred' },
                { col: 2, className: 'extra-row-cash-flow', title: 'Tax Exempt' },
                { col: 2, className: 'extra-row-cash-flow', title: 'RILA/Vol Buff FIA' },
                { col: 1, className: 'extra-row-cash-flow', title: 'Vol Buff Ins' },
                { col: 1, className: 'extra-row-cash-flow', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },
                { col: 1, className: '', title: '' },

              ]}
              columnTitles={[
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year", },
                { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["beginningAccountValue"], title: "Beg Acct Value", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalInflow"], title: "Total Inflows", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["totalOutflow"], title: "Total Outflows", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["excessIncome"], title: "Excess Income", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxableAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["grossTaxableDistribution"], title: "Gross Taxable Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxDeferredAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["grossTaxDeferredDistribution"], title: "Gross Tax Deferred Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["taxExemptAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["grossTaxExemptDistribution"], title: "Gross Tax Exempt Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaAccountContribution"], title: "Contr", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaDistribution"], title: "FIA Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceAccountDistribtuion"], title: "Ins Dist", function: currencyFormatNoDecimals },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["portfolioReturns"], title: "Port Returns", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["fiaIndexReturn"], title: "RILA/FIA Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["insuranceCashValueReturn"], title: "Cash Value Return", function: (i) => formatNumberToPercentage(i, 2) },
                { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["cumulativeWealth"], title: "Cumulative Wealth", function: currencyFormatNoDecimals },

              ]}
              data={futureCashInflow?.toJS()?.cashFlowSummary || []}
            />
          )}
          {tab === 4 && (
            fiaReports.map((fiaReport, idx) => {
              return <DinamicTable
                key={idx}
                extraHeaderRow={true}
                extraHeaderRowColSpan={[
                  { col: 9, className: 'extra-row-cash-flow', title: 'Guaranteed Income FIA' },
                  { col: 2, className: 'extra-row-cash-flow', title: 'Income Rider' },

                ]}
                columnTitles={[
                  { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["endOfContractYear"], title: "End Of Contract Year" },
                  { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["netPremiumAndBonus"], title: "Net Premium + Bonus", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["creditedInterest"], title: "Credited Interest", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["accumulationValue"], title: "Accumulation Values", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["deathBenefit"], title: "Death Benefits", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["beginningOfYearlifetimeWithdrawalPercent"], title: "Beginning of Year Lifetime Withdrawal Percent", function: formatNumberToPercentage },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["withdrawalContract"], title: "Withdrawal (Contract)", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["benefitBase"], title: "Benefit Base", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["rollupAmount"], title: "Rollup Amount", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["withdrawalIncomeRider"], title: <> Withdrawal<br />(Income Rider)</>, function: currencyFormatNoDecimals },
                ]}
                data={fiaReport}
              />
            })

          )}
          {tab === 5 && (
            insuranceReports.map((insurance, idx) => {
              return <DinamicTable
                key={idx}
                columnTitles={[
                  { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["year"], title: "Year" },
                  { alignCell: "center", alignHeader: "center", classNameCell: "current-roadmap-cell", key: ["clientAge", "coClientAge"], title: "Client/Spouse", function: mergeClientCoClientAge },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["premiumOutlay"], title: "Premium Outlay", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["distribution"], title: "Distribution", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["netCashValue"], title: "Net Cash Value", function: currencyFormatNoDecimals },
                  { alignCell: "center", alignHeader: "center", classNameCell: "", key: ["netDeathBenefits"], title: "Net Death Benefits", function: currencyFormatNoDecimals },
                ]}
                data={insurance}
              />
            })
          )}
        </div>
      </Grid>
    </Grid >
  );
};

export default PresentationFuture;
